import { createReducer, createActions } from "reduxsauce";
import Immutable from "seamless-immutable";

const { Types, Creators } = createActions({
  getPagesRequest: null,
  getPagesSuccess: ["data"],
  getPagesFetchingReset: null,

  sendSuggestRequest: ['data'],
  sendSuggestSuccess: ['sendSuggestResult'],
  sendSuggestReset: null,

  sendHelpRequest: ['data'],
  sendHelpSuccess: ['sendHelpResult'],
  sendHelpReset: null,
});


export const SuggestaFutureTypes = Types;
export default Creators;

/* ------------- Initial State ------------- */

export const INITIAL_STATE = Immutable({
  data: [],  
  fetching: false,

  sendSuggestResult: null,
  sendSuggestFetching: false, 

  sendHelpResult: null,
  sendHelpFetching: false,   
});

/* ------------- Reducers ------------- */

export const getPagesRequest = (state) => {
  return state.merge({ fetching: true })
}

export const getPagesSuccess = (state, {data}) => {
  return state.merge({ fetching: false, data: data })
}

export const getPagesFetchingReset = (state) => {
  return state.merge({ fetching:false })
}

export const sendSuggestRequest = (state, { data }) => {
  return state.merge({ sendSuggestFetching: true })
}
export const sendSuggestSuccess = (state, { sendSuggestResult }) => {
  return state.merge({ sendSuggestFetching: false, sendSuggestResult })
}
export const sendSuggestReset = (state) =>{
  return state.merge({ sendSuggestFetching: false, sendSuggestResult: null})
}

export const sendHelpRequest = (state, { data }) => {
  return state.merge({ sendHelpFetching: true })
}
export const sendHelpSuccess = (state, { sendHelpResult }) => {
  return state.merge({ sendHelpFetching: false, sendHelpResult })
}
export const sendHelpReset = (state) =>{
  return state.merge({ sendHelpFetching: false, sendHelpResult: null})
}

/* ------------- Hookup Reducers To Types ------------- */

export const reducer = createReducer(INITIAL_STATE, {
  [Types.GET_PAGES_REQUEST]: getPagesRequest,
  [Types.GET_PAGES_SUCCESS]: getPagesSuccess, 
  [Types.GET_PAGES_FETCHING_RESET]: getPagesFetchingReset,
  
  [Types.SEND_SUGGEST_REQUEST]: sendSuggestRequest,
  [Types.SEND_SUGGEST_SUCCESS]: sendSuggestSuccess,
  [Types.SEND_SUGGEST_RESET]: sendSuggestReset,

  [Types.SEND_HELP_REQUEST]: sendHelpRequest,
  [Types.SEND_HELP_SUCCESS]: sendHelpSuccess,
  [Types.SEND_HELP_RESET]: sendHelpReset,
});
